/**
 * Pronto Posto – Maildaten · Französisch (fr-FR) · KS04
 *
 * KS04 Flug – Lady Luna / Maxime Legrand. Postfach: m.legrand@pronto-posto.com
 *
 * Aufteilung nach language/episode: geteilte Inhalte einer Sprache leben in ./_shared.js.
 * Sprachen sind strikt getrennt – Mails dieser Datei adressieren ausschliesslich Postfaecher
 * dieser Sprache. IDs sind global eindeutig (siehe ID-Reservierungen in den Blockkommentaren).
 */
/* eslint-disable */

export function getEmails() {
    return [
        // luna–legrand mails (ks04 flug) — FR (Maxime Legrand account: m.legrand@pronto-posto.com)
        {
            id: 41,
            from: { email: 'lady.luna@explorame-tv.fr', name: 'Lady Luna', avatar: require('@src/assets/images/portrait/luna.jpg').default },
            to: [{ name: 'Max Legrand', email: 'm.legrand@pronto-posto.com' }],
            subject: 'Re: Demande : séance spéciale dans votre émission',
            cc: [], bcc: [],
            message: "Max,<p>ce sujet a l'air de beaucoup vous tenir à cœur. Pour être tout à fait sûrs que les cartes ne décident pas soudainement autrement — ou que je ne me trahisse pas pendant l'émission —, il faudrait plutôt compter 6 000 € d'honoraires.<p>Cordialement,<p>Lady Luna",
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Thu. Mar. 28 2024 15:08:00 GMT+0000 (GMT)',
            replies: [
                {
                    id: 40,
                    from: { email: 'm.legrand@pronto-posto.com', name: 'Max Legrand', avatar: require('@src/assets/images/portrait/lange.jpg').default },
                    to: [{ name: 'Lady Luna', email: 'lady.luna@explorame-tv.fr' }],
                    subject: 'Demande : séance spéciale dans votre émission',
                    cc: [], bcc: [],
                    message: "Bonjour Lady Luna,<p>si je vous cerne bien, nous sommes pour ainsi dire des collègues de métier, et vous n'êtes jamais contre un petit revenu supplémentaire.<p>J'aurais une mission spéciale à vous confier : ma belle-mère superstitieuse, Cristina Zaplana, va probablement vous appeler le 31/03 pour les 10 ans de votre chaîne. C'est l'une de vos fidèles téléspectatrices. Elle doit, coûte que coûte, être convaincue de céder sa villa de campagne à sa fille (et à moi). Faites en sorte, pendant l'émission, que les cartes recommandent clairement cette donation — peu importe ce qu'elles disent vraiment.<p>Je propose 3 000 € d'honoraires. Je compte sur votre discrétion.<p><p>Cordialement,<p>Max Legrand",
                    attachments: [],
                    isStarred: false,
                    labels: ['personal'],
                    time: 'Thu. Mar. 28 2024 14:02:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'sent',
                    isRead: true
                }
            ],
            folder: 'inbox',
            isRead: true
        },
        {
            id: 43,
            from: { email: 'lady.luna@explorame-tv.fr', name: 'Lady Luna', avatar: require('@src/assets/images/portrait/luna.jpg').default },
            to: [{ name: 'Max Legrand', email: 'm.legrand@pronto-posto.com' }],
            subject: 'Re: Re: Re: Demande : séance spéciale dans votre émission',
            cc: [], bcc: [],
            message: "L'argent est bien arrivé. Je vais orienter les cartes comme convenu — votre belle-mère recevra le signe parfait en faveur de la donation.<p>Je vous ferai parvenir un best-of dès que l'émission sera dans la boîte.<p>Au plaisir de faire encore de bonnes affaires,<p>Lady Luna",
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Thu. Mar. 28 2024 21:58:00 GMT+0000 (GMT)',
            replies: [
                {
                    id: 42,
                    from: { email: 'm.legrand@pronto-posto.com', name: 'Max Legrand', avatar: require('@src/assets/images/portrait/lange.jpg').default },
                    to: [{ name: 'Lady Luna', email: 'lady.luna@explorame-tv.fr' }],
                    subject: 'Re: Re: Demande : séance spéciale dans votre émission',
                    cc: [], bcc: [],
                    message: "C'est du chantage ou quoi ???? Quel culot. Mais bon, je suis de bonne humeur aujourd'hui. 5 000 € et pas un centime de plus. De préférence en crypto. Appelons-nous tout à l'heure. +33 XXXXX152.",
                    attachments: [],
                    isStarred: false,
                    labels: ['personal'],
                    time: 'Thu. Mar. 28 2024 18:22:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'sent',
                    isRead: true
                }
            ],
            folder: 'inbox',
            isRead: true
        },
        {
            id: 44,
            from: { email: 'lady.luna@explorame-tv.fr', name: 'Lady Luna', avatar: require('@src/assets/images/portrait/luna.jpg').default },
            to: [{ name: 'Max Legrand', email: 'm.legrand@pronto-posto.com' }],
            subject: 'Les cartes ont parlé',
            cc: [], bcc: [],
            message: "Max,<p>Les cartes ont parlé. Vous trouverez en pièce jointe le clip concernant notre petit arrangement.<p>Au plaisir de faire encore de bonnes affaires,<p>Lady Luna<p>PS : si vous avez besoin d'aide plus souvent : chez ExplorÂmeTV, il y a une solution à chaque préoccupation, tant que l'univers (et votre compte en banque) veut bien coopérer.",
            attachments: [
                {
                    fileName: 'ExplorAmeTV_transcription_de_test.pdf',
                    thumbnail: require('@src/assets/images/icons/jpg.png').default,
                    url: 'https://start.crime-cases.app/ks04-fr-test/E_common.pdf',
                    size: 'Transcription FR — test',
                },
            ],
            isStarred: true,
            labels: ['personal'],
            time: 'Sun. Mar. 31 2024 15:45:00 GMT+0000 (GMT)',
            replies: [
                {
                    id: 45,
                    from: { email: 'm.legrand@pronto-posto.com', name: 'Max Legrand', avatar: require('@src/assets/images/portrait/lange.jpg').default },
                    to: [{ name: 'Lady Luna', email: 'lady.luna@explorame-tv.fr' }],
                    subject: 'Re: Les cartes ont parlé',
                    cc: [], bcc: [],
                    message: "Je viens de regarder le best-of, mec quelle bande de tarés hahaha, je pensais que ça n'existait que dans la bulle crypto. Mais peu importe, Cristina a mordu à l'hameçon. <p>Merci pour le soutien « divin ».<p>Je reviens vers vous si besoin !",
                    attachments: [],
                    isStarred: false,
                    labels: ['personal'],
                    time: 'Sun. Mar. 31 2024 18:40:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'sent',
                    isRead: true
                },
            ],
            folder: 'inbox',
            isRead: true
        },
        {
            id: 46,
            from: { email: 'renderrambo@pronto-posto.com', name: 'Render Rambo', avatar: require('@src/assets/images/portrait/rambo.jpg').default },
            to: [{ name: 'Max Legrand', email: 'm.legrand@pronto-posto.com' }],
            subject: 'Nouveau Reel',
            cc: [], bcc: [],
            message: "Hey Maxx,<p>J'ai fini de monter ton reel, il est devenu vraiment stylé ! Les finance bros vont adorer. Envoie-moi le paiement direct en BillionCoins, tu m'as carrément convaincu :P<p>Dis-moi surtout si la vidéo te plaît comme ça, ou si je dois encore changer un truc.<p>La vidéo est en pièce jointe<p>P.S : n'oublie pas de m'inviter à bord de ton nouveau bolide ;)",
            attachments: [
                {
                    fileName: 'CryptoReel_transcription_de_test.pdf',
                    thumbnail: require('@src/assets/images/icons/mp4.png').default,
                    url: 'https://start.crime-cases.app/ks04-fr-test/C-A_common.pdf',
                    size: 'Transcription FR — test',
                },
            ],
            isStarred: false,
            labels: ['work'],
            time: 'Sun. Feb. 25 2024 16:45:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: true
        },
    ]
}

export function getSpam() {
    return [
        //ks04 flug — FR (Maxime Legrand account: m.legrand@pronto-posto.com)
        {
            id: 130,
            from: { email: 'omar@takatookaland-royal.org', name: 'Prince Omar', avatar: require('@src/assets/images/portrait/prince.jpg').default },
            to: [{ name: 'Maxime Legrand', email: 'm.legrand@pronto-posto.com' }],
            subject: 'Le prince Omar a besoin de votre aide !',
            cc: [], bcc: [],
            message: "<p>Cher ami,</p><p>Je suis le prince Omar du lointain royaume de Takatoukaland. Hélas, je suis coincé avec des millions de pièces d'or que vous seul pouvez sauver !</p><p>Aidez-moi à transférer ma fortune sur votre compte, et vous recevrez à vie des invitations aux garden-parties royales.</p><p><b>Faites vite, mes réserves de thé sont limitées !</b></p><br><p>Votre désespéré prince Omar</p>",
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Wed. Jul. 10 2024 18:24:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },
        {
            id: 131,
            from: { email: 'info@wellbeingwonders.com', name: 'Équipe Bien-être Miracle', avatar: require('@src/assets/images/portrait/vitamins.jpg').default },
            to: [{ name: 'Maxime Legrand', email: 'm.legrand@pronto-posto.com' }],
            subject: 'Les médecins sont sous le choc ! Les légumes sont inutiles !',
            cc: [], bcc: [],
            message: "<p>Cher ami soucieux de votre santé,</p><p>Oubliez le brocoli, les épinards et les carottes ! Nos oursons gélifiés révolutionnaires contiennent toutes les vitamines dont vous pourriez avoir besoin.</p><p>Commandez aujourd'hui et nous vous offrons en plus un paquet de salade au chocolat gratuit !</p><br><p>Restez en bonne santé,<br>Votre équipe Bien-être Miracle</p>",
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Thu. Jul. 18 2024 20:11:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },
        {
            id: 132,
            from: { email: 'service@cosmic-realestate.com', name: 'Équipe Immobilier Cosmique', avatar: require('@src/assets/images/portrait/moon.jpg').default },
            to: [{ name: 'Maxime Legrand', email: 'm.legrand@pronto-posto.com' }],
            subject: 'Votre propre terrain sur la Lune vous attend !',
            cc: [], bcc: [],
            message: "<p>Cher futur propriétaire lunaire,</p><p>Saisissez dès maintenant votre chance unique de devenir propriétaire officiel d'un terrain sur la Lune.</p><p>Réservez aujourd'hui un emplacement exclusif avec une vue imprenable sur la Terre. Disponibilité limitée !</p><br><p>Votre équipe Immobilier Cosmique</p>",
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Tue. Jul. 23 2024 10:50:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },
        {
            id: 133,
            from: { email: 'jobs@aqua-careers.org', name: 'Équipe Carrières Aquatiques', avatar: require('@src/assets/images/portrait/dolphin.jpg').default },
            to: [{ name: 'Maxime Legrand', email: 'm.legrand@pronto-posto.com' }],
            subject: 'Nous recherchons des traducteurs de dauphins – opportunité lucrative !',
            cc: [], bcc: [],
            message: "<p>Cher amoureux de la mer,</p><p>Êtes-vous prêt pour une carrière hors du commun ?</p><p>Nous recherchons de toute urgence des personnes capables de comprendre le langage des dauphins ou désireuses de l'apprendre. Aucune expérience requise, rémunération généreuse garantie.</p><p>Postulez dès aujourd'hui !</p><br><p>Votre équipe Carrières Aquatiques</p>",
            attachments: [],
            isStarred: false,
            labels: ['company'],
            time: 'Mon. Jul. 29 2024 04:01:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },
    ]
}
